module.exports = __webpack_public_path__ + "static/media/social.c6882834.jpg";